// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__crlYx","info":"UpdateTermsInfo_info__2Bceg"};